<template>
  <div>
    <v-sheet
      outlined
      min-height="75vh">

      <!-- Imagen para pantallas pequeñas (xs) -->
      <v-img
        class="image-landing"
        height="80"
        v-if="$vuetify.breakpoint.xsOnly && waiting_room_sm_image"
        :src="waiting_room_sm_image"
        max-height="80px"
      ></v-img>

      <!-- Imagen para pantallas medianas y grandes (md y superiores) -->
      <v-img
        class="image-landing"
        height="120"
        v-if="!$vuetify.breakpoint.xsOnly && waiting_room_image"
        :src="waiting_room_image"
        max-height="120px"
      ></v-img>

      <v-row class="pa-6">
        <v-col cols="12" class="pt-8">

          <h3>¡Hola <b>{{ user.name.toUpperCase() }}!</b></h3> 
            <p class="pt-4">
              Es un placer saludarte, queremos comunicarte que lamentablemente este 
              año el proyecto <b>{{ convocation_form.convocation_form.title}} </b> 
              <i>NO HA SIDO SELECCIONADO</i> para participar en las 
              <b>{{ edition.edition.name}}</b>.
            </p>
            <p>
              Agradecemos la dedicación y el esfuerzo e invitamos a participar en 
              las próximas ediciones! Recordá que podrás/n participar igualmente de 
              todas las actividades previstas para esta edición a partir del 
              {{ handleDate(edition.edition.start_date_public_access) }}.
            </p>
            <p>
              Por correo electrónico se enviarán las observaciones realizadas por el 
              Comité Evaluador para que puedan ser tenidas en cuenta para posibles mejoras 
              del proyecto.
            </p>
            <p>
              Quedamos pendientes de cualquier consulta que quieras/n acercarnos.
            </p>
            <p>
              ¡Saludos!
            </p>

        </v-col>
      </v-row>
      
    </v-sheet>
  </div>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL
  import { mapGetters } from 'vuex'

  export default {
    name: 'entrepreneurRejected',
    data: () => ({
      loading:true,
      dialog:false,
      waiting_room_image: null,
      waiting_room_sm_image: null
    }),

    computed: {
      ...mapGetters([
        'isLogged', 'drawer', 'user', 'convocation_form', 'edition'
      ])
    },

    methods:{
      setData(){
        if(this.edition.edition.edition_customization.waiting_room_image!=null){
          this.waiting_room_image = APP_URL + this.edition.edition.edition_customization.waiting_room_image
        }

        if(this.edition.edition.edition_customization.waiting_room_sm_image!=null){
          this.waiting_room_sm_image = APP_URL + this.edition.edition.edition_customization.waiting_room_sm_image
        }
      },

      handleDate(date){
        if(!date){
          return ' -- (fecha a definir)'
        }

        // Split the date into parts
        let parts = date.split("-");
        let year = parts[0];
        let month = parts[1];
        let day = parts[2];
        
        // Rearrange the parts into the desired format
        let formattedDate = `${day}/${month}/${year}`;
        
        return formattedDate;
      }
    },
    created(){
      Promise.all([
        this.setData()
      ]).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.image-landing{
	position: relative;
	max-width: 100vw;
	width: 100%;
  border-bottom: 4px solid #00a1b8;
}
</style>